<template>
    <div class="wrap">
        <div class="title">
            <div class="title_left">餐厨垃圾</div>
        </div>
       <div class="innerBox">
			<ErrorTemplate></ErrorTemplate>
		</div>
    </div>
</template>

<script>
    export default {
        name: "trashList"
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: calc(100% - 40px);
        padding: 0 20px;
        height: 100%;
        background: #f6f6f6;
    .title{
        height: 60px;
        line-height: 60px;
    .title_left{
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 50%;
        height: 100%;
    }
    }
    .innerBox {
        width: calc(100% - 60px);
        padding: 20px 30px;
        height: calc(100% - 125px);
        background: #fff;
        border-radius: 10px;
    }
    }
</style>